const contactData = {
    email: "ashis.n.patel@gmail.com",
    phone: "281-610-6460",
    address: "College Station, Tx 77840",
}

export default contactData; 